module.exports = __webpack_public_path__ + "static/media/css.7d4fe56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/css.png
// module id = 2547
// module chunks = 0